module.exports = [
    {
        path:"/confirmOrder",
        name:"支付订单",
        component:()=>import("../../components/order/confirmOrder.vue"),
        meta:{
            requireAuth:true //要权限
        }
    },
    {
        path:"/newOrder",
        name:"确认订单",
        component:()=>import("../../components/order/newOrder.vue"),
        meta:{
            requireAuth:true //要权限
        }
    },
    {
        path:"/orderDetial",
        name:"订单明细",
        component:()=>import("../../components/order/orderDetail.vue"),
        meta:{
            requireAuth:true //要权限
        }
    },
    {
        path:"/batchOrder",
        name:"批量下单",
        component:()=>import("../../components/order/batchOrder.vue"),
        meta:{
            requireAuth:true //要权限
        }
    },
    {
        path:"/bookList",
        name:"书目下载",
        component:()=>import("../../components/order/bookListDownload.vue"),
        meta:{
            requireAuth:true //要权限
        }
    },
    
    {
        path:"/whNewOrder",
        name:"供应商确认订单",
        component:()=>import("../../components/order/whNewOrder.vue"),
        meta:{
            requireAuth:true //要权限
        }
    },
    {
        path:"/whConfirmOrder",
        name:"供应商支付订单",
        component:()=>import("../../components/order/whConfirmOrder.vue"),
        meta:{
            requireAuth:true //要权限
        }
    },
    {
      path: "whOrderDetail",
      name: "供应商订单明细",
      component: () => import("../../components/provider/whOrderDetail.vue"),
      meta: {
        requireAuth: true,
      },
    },

    
]